// Empty origin uses the same host in production. CRA proxies API requests in development.
export const STORE_ORIGIN = (process.env.REACT_APP_STORE_ORIGIN || '').replace(/\/$/, '');
